import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import GraphSummaryGraph from '../GraphSummaryGraph'
import UserSummaryGraph from '../UserSummaryGraph'

interface GraphSummaryListingProps {
	data: any
	userData: any
}

export default function GraphSummaryListing({
	data,
	userData,
}: GraphSummaryListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`สรุปยอดฝากถอน`} description="สรุปยอดฝากถอน" />
			</div>
			<Separator />
			<GraphSummaryGraph data={data} />
			<UserSummaryGraph data={userData} />
		</div>
	)
}
